import type { FunctionComponent } from 'react';
import useGetPricesByPlan from '../../../../utils/hooks/useGetPricesByPlan';
import * as styles from './TermsAndConditions.module.scss';

export const DISCLAIMER_NOTE =
  '**vs. Comp value & based on annual members who shopped at least one additional sale in 2022.';

const TermsAndConditions: FunctionComponent = () => {
  const { annualPrice } = useGetPricesByPlan();
  const formattedAnnualPrice = annualPrice && `${annualPrice?.annualPrice}`;

  const DISCLAIMER_CONFIRM = `By clicking “YES, UPGRADE ME”, you authorize us to charge $${formattedAnnualPrice} USD, minus any applicable discount, to the payment method on file for an annual subscription. Sales tax will also be charged, where applicable. Free shipping on boxes shipped in contiguous US. Shipping charges of $8 USD per box applies for shipping to Canada, Hawaii, Alaska and Puerto Rico. Shipping charges of $10 USD per box applies for shipping to the United Kingdom. Foreign exchange or transaction fees may apply for non-US customers. Subscription will auto-renew after 4 boxes. Cancel anytime.
  **vs. Comp value & based on annual members who shopped at least one additional sale in 2022.`;

  return (
    <div className={styles.termsAndConditionsWrapper}>
      <p>{DISCLAIMER_CONFIRM}</p>
      <p>{DISCLAIMER_NOTE}</p>
    </div>
  );
};

export default TermsAndConditions;
